module.exports = __webpack_public_path__ + "img/pota-twitter.7add8400.jpg";